import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["format"];
import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker as MuiDatepicker } from "@mui/x-date-pickers/DatePicker";
import { jsx as ___EmotionJSX } from "@emotion/react";
var customTheme = createTheme();
export var Datepicker = function Datepicker(_ref) {
  var _ref$format = _ref.format,
      format = _ref$format === void 0 ? "dd/MM/yyyy" : _ref$format,
      rest = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, ___EmotionJSX(ThemeProvider, {
    theme: customTheme
  }, ___EmotionJSX(MuiDatepicker, _extends({
    format: format
  }, rest))));
};
Datepicker.displayName = "Datepicker";
export default Datepicker;